(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7983],{

/***/ 70402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ linked_profiles_beta; }
});

// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation2/index.ts + 91 modules
var Navigation2 = __webpack_require__(92609);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(24330);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 23 modules
var FormFields = __webpack_require__(20444);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/sharedEmail.ts
var sharedEmail = __webpack_require__(13206);
// EXTERNAL MODULE: ../../libs/utils/regexes/email.ts
var email = __webpack_require__(36219);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/utils/regexes/lastName.ts
var lastName = __webpack_require__(51895);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/TextArea/index.ts + 2 modules
var TextArea = __webpack_require__(94721);
// EXTERNAL MODULE: ../../libs/matcha/components/CheckboxField/index.ts + 2 modules
var CheckboxField = __webpack_require__(72182);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/ErrorSlot.tsx + 1 modules
var ErrorSlot = __webpack_require__(19727);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/LinkedProfiles/components/Hero/WarehouseField.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var warehouseCheckboxesMessages = {
  required: "Please select at least one warehouse."
};
var warehouseMessages = {
  required: "Please provide your warehouse.",
  invalid: "Please provide a valid warehouse."
};

/**
 * Warehouse field
 */
var WarehouseField = function WarehouseField(_ref) {
  var _errors$otherWarehous;

  var data = _ref.data;

  var _useState = (0,react.useState)(false),
      other = _useState[0],
      setOther = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isDirty = _useState2[0],
      setIsDirty = _useState2[1];

  var _useState3 = (0,react.useState)(new Array(data.length).fill("")),
      checkBoxesSelected = _useState3[0],
      setCheckBoxesSelected = _useState3[1];

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      clearErrors = _useFormContext.clearErrors,
      setError = _useFormContext.setError,
      errors = _useFormContext.formState.errors;

  var checkSelection = function checkSelection(idx, value, checked) {
    var arr = (0,toConsumableArray/* default */.Z)(checkBoxesSelected);

    arr[idx] = checked ? value : "";
    setCheckBoxesSelected(arr);
  };

  (0,react.useEffect)(function () {
    var isValid = checkBoxesSelected.some(function (c) {
      return c;
    });

    if (isValid) {
      clearErrors("selectedWarehouses");
    } else if (!errors.selectedWarehouses && isDirty) {
      setError("selectedWarehouses", {
        type: "required",
        message: warehouseCheckboxesMessages.required
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [checkBoxesSelected]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CheckBoxesWrapper, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label, {
        variant: "formLabel",
        children: " Which warehouse does your business use? "
      }), [].concat((0,toConsumableArray/* default */.Z)(data), ["Other"]).map(function (title, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckboxField/* default */.Z, _objectSpread(_objectSpread({
          label: title,
          value: title
        }, register("selectedWarehouses")), {}, {
          onChange: function onChange(checkField) {
            setIsDirty(true);
            var _checkField$target = checkField.target,
                value = _checkField$target.value,
                checked = _checkField$target.checked;
            if (value === "Other") setOther(checked);
            checkSelection(index, value, checked);
          }
        }), "".concat(title, "-").concat(index));
      }), errors.selectedWarehouses ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorSlot/* default */.Z, {
        errorText: errors.selectedWarehouses.message
      }) : null]
    }), other ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextArea/* default */.Z, _objectSpread({
      id: "otherWarehouse",
      label: "Please share your warehouse",
      placeholder: "Please share your warehouse",
      "aria-label": "Please share your warehouse",
      error: Boolean(errors.otherWarehouse),
      errorText: (_errors$otherWarehous = errors.otherWarehouse) === null || _errors$otherWarehous === void 0 ? void 0 : _errors$otherWarehous.message,
      expanded: true
    }, register("otherWarehouse", {
      required: warehouseMessages.required
    }))) : null]
  });
};

var Label = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e167d7bi1"
} : 0)("margin:0;display:block;color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[80];
}, ";" + ( true ? "" : 0));
var CheckBoxesWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e167d7bi0"
} : 0)( true ? {
  name: "172hj2b",
  styles: "position:relative;display:grid;row-gap:18px"
} : 0);
/* harmony default export */ var Hero_WarehouseField = (WarehouseField);
;// CONCATENATED MODULE: ./src/views/LinkedProfiles/components/Hero/HeroForm.tsx



function HeroForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function HeroForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? HeroForm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : HeroForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function HeroForm_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/* eslint-disable camelcase */



















var formData = {
  id: "linked-profiles-beta-request",
  buttonText: "Request a Beta Invitation",
  successMessage: "You\u2019re on the list for the Linked Profiles Beta!",
  warehouses: ["Snowflake", "BigQuery", "Redshift", "Azure Synapse", "Databricks", "Postgres"]
};
var schema = lib/* object */.Ry({
  name: lib/* string */.Z_({
    required_error: FormFields/* fullNameMessages.required */.aZ.required
  }).regex(regexes_form/* default */.Z, {
    message: FormFields/* fullNameMessages.invalid */.aZ.invalid
  }).regex(lastName/* default */.Z, {
    message: FormFields/* fullNameMessages.invalid */.aZ.invalid
  }),
  email: lib/* string */.Z_({
    required_error: FormFields/* companyEmailMessages.required */.BN.required
  }).regex(regexes_form/* default */.Z, {
    message: FormFields/* companyEmailMessages.invalid */.BN.invalid
  }).regex(email/* default */.Z, {
    message: FormFields/* companyEmailMessages.invalid */.BN.invalid
  })
  /* This is equal to .email( { message: companyEmailMessages.invalid }) but with a custom regex */
  .regex(sharedEmail/* default */.C, {
    message: FormFields/* companyEmailMessages.sharedEmail */.BN.sharedEmail
  }),
  jobTitle: lib/* string */.Z_({
    required_error: FormFields/* jobTitleMessages.required */.cY.required
  }).regex(regexes_form/* default */.Z, {
    message: FormFields/* jobTitleMessages.invalid */.cY.invalid
  }),
  workspace: lib/* string */.Z_({
    required_error: FormFields/* segmentWorkspaceMessages.required */.ZK.required
  }).regex(regexes_form/* default */.Z, {
    message: FormFields/* segmentWorkspaceMessages.invalid */.ZK.invalid
  }),
  selectedWarehouses: lib/* string */.Z_().array().nonempty({
    message: warehouseCheckboxesMessages.required
  }),
  otherWarehouse: lib/* string */.Z_({
    required_error: warehouseMessages.required
  }).regex(regexes_form/* default */.Z, {
    message: warehouseMessages.invalid
  })
}).partial({
  otherWarehouse: true
});
/* eslint-enable camelcase */

var HeroForm = function HeroForm() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var mobileResolutionMediaQuery = theme.breakpoints.down("md", false);
  var isSmallResolution = (0,useMatchMedia/* default */.Z)(mobileResolutionMediaQuery, true);
  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema),
    defaultValues: {
      selectedWarehouses: []
    }
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
    id: formData.id,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, {
      gap: "small",
      methods: methods,
      success: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, {
        status: "success",
        "data-hook": "linked-profiles-beta-request-success-message",
        heading: formData.successMessage
      }),
      error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, HeroForm_objectSpread({
        status: "error",
        "data-hook": "linked-profiles-beta-request-error-message"
      }, TrackableForm/* errorMessage */.N)),
      onSubmit: function onSubmit(data) {
        (0,useScrollToAnchor/* scrollToAnchor */.d)(formData.id, isSmallResolution ? -150 : -120, false);
        (0,scripts/* trackProgramSignupForm */.XT)(data);
      },
      customFormIdentifier: formData.id,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* FullNameField */.AM, {
        label: "Full Name"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyEmailField */.Ot, {
        label: "Email Address",
        placeholder: "Email of your Segment Workspace"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyJobTitle */.jj, {
        label: "Job Title",
        name: "jobTitle",
        id: "jobTitle",
        placeholder: "Job title"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* SegmentWorkspaceField */.D6, {
        label: "Segment Workspace Name"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_WarehouseField, {
        data: formData.warehouses
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          color: "primary",
          variant: "filled",
          size: "large",
          expanded: true,
          children: formData.buttonText
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisclaimerWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {})
      })]
    })
  });
};

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1f4rjcb2"
} : 0)( true ? {
  name: "1flj9lk",
  styles: "text-align:left"
} : 0);

var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1f4rjcb1"
} : 0)( true ? "" : 0);

var DisclaimerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1f4rjcb0"
} : 0)( true ? "" : 0);

/* harmony default export */ var Hero_HeroForm = (HeroForm);
;// CONCATENATED MODULE: ./src/views/LinkedProfiles/components/Hero/Hero.tsx










var getCopy = function getCopy(pageConfig) {
  return {
    overline: "Linked Profiles",
    heading: "Request a Beta Invitation",
    description: [{
      paragraph: "Linked Profiles will empower data teams and marketers to work together by bridging the gap between the two teams so marketers can expand into use cases that were never before possible. Enable marketers to build and iterate on hyper personalized campaigns quickly vs constantly working through data alignment problems."
    }, {
      paragraph: "Sign up to get on the list for our beta program."
    }, {
      paragraph: "Note: You must be a Unify customer to participate in the Beta. To get started with Unify, <a href=\"".concat((0,getAbsoluteUrl/* default */.Z)("/product/unify/", pageConfig), "\">request a demo here</a>.")
    }]
  };
};

var Hero = function Hero() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var copy = getCopy(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeroRecipeBaseStyled, {
      variant: "2Col",
      copyVariant: "narrow",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
          variant: "h5",
          tag: "p",
          children: copy.overline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h1",
          tag: "h1",
          children: copy.heading
        }), copy.description.map(function (text, index) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pExtraLarge",
            dangerouslySetInnerHTML: {
              __html: sanitize_html_default()(text.paragraph, {
                allowedTags: ["a"]
              })
            }
          }, index);
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Form */.l0, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_HeroForm, {})
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "eprhm6p1"
} : 0)( true ? "" : 0);

var HeroRecipeBaseStyled = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "eprhm6p0"
} : 0)(recipes_Hero/* Wrapper */.im, "{justify-items:flex-start;align-items:flex-start;}" + ( true ? "" : 0));

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ./src/views/LinkedProfiles/assets/OgImage.jpeg
var OgImage = __webpack_require__(48283);
var OgImage_default = /*#__PURE__*/__webpack_require__.n(OgImage);
;// CONCATENATED MODULE: ./src/views/LinkedProfiles/LinkedProfiles.tsx









var LinkedProfilesView = function LinkedProfilesView() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Linked Profiles Beta Sign Up | Twilio Segment",
      pageDescription: "Linked Profiles makes it easy to bring data from your warehouse into any tracked event in Segment before it is sent to any of our supported applications. Sign up to get on the list for our beta program today and to be notified when we move into GA later this year.",
      pageOG: (OgImage_default()),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation2/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("main", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {})
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var LinkedProfiles_LinkedProfiles = (LinkedProfilesView);
;// CONCATENATED MODULE: ./src/pages/linked-profiles-beta.tsx



var LinkedProfiles = function LinkedProfiles() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkedProfiles_LinkedProfiles, {});
};

/* harmony default export */ var linked_profiles_beta = (LinkedProfiles);

/***/ }),

/***/ 72182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CheckboxField; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/Checkbox/index.ts + 2 modules
var Checkbox = __webpack_require__(38128);
// EXTERNAL MODULE: ../../libs/matcha/components/Fieldset/FieldsetContext.tsx
var FieldsetContext = __webpack_require__(83734);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/components/CheckboxField/CheckboxField.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var _ref =  true ? {
  name: "1k4lyc2",
  styles: "opacity:0.5;cursor:not-allowed"
} : 0;

var Label = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("label",  true ? {
  target: "e1e8l1r51"
} : 0)("display:grid;grid-template-columns:min-content auto;cursor:pointer;", function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && _ref;
}, ";" + ( true ? "" : 0));
var Text = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1e8l1r50"
} : 0)( true ? {
  name: "1ym883w",
  styles: "margin:0;padding-left:12px"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/CheckboxField/CheckboxField.tsx


var _excluded = ["name", "label", "disabled", "onChange", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var BaseCheckboxField = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var name = _ref.name,
      label = _ref.label,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var fieldsetContext = (0,FieldsetContext/* useFieldset */.w)();
  var isDisabled = disabled || (fieldsetContext === null || fieldsetContext === void 0 ? void 0 : fieldsetContext.disabledFieldset);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Label, {
    disabled: isDisabled,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, _objectSpread({
      name: name,
      disabled: Boolean(isDisabled),
      onChange: onChange,
      ref: ref,
      tokens: tokens.checkbox
    }, rest)), typeof label === "string" ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
      variant: "formInput",
      tokens: tokens.label,
      children: label
    }) : label]
  });
});
var CheckboxField = (0,useDesignTokens/* withDesignTokens */.Y)(BaseCheckboxField, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      checkbox: {},
      label: {
        color: theme.palette.brand.darkAcai[500]
      }
    };
  },
  dark: function dark(theme) {
    return {
      checkbox: {},
      label: {
        color: theme.palette.brand.darkAcai[400]
      }
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      checkbox: {},
      label: {
        color: theme.palette.twilio.gray[100]
      }
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/components/CheckboxField/index.ts


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 51895:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var lastName = /^(?![\s\S]*\s[;,?=+\-@])[^;,?=+\-@\s][\s\S]+$/g;
/* harmony default export */ __webpack_exports__["Z"] = (lastName);

/***/ }),

/***/ 73297:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/linked-profiles-beta",
      function () {
        return __webpack_require__(70402);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48283:
/***/ (function(module) {

module.exports = "/_next/static/images/OgImage-7855d49bf1ace212e7feabd5964a0350.jpeg";

/***/ }),

/***/ 76527:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 96969:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 32232:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 24195:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,8834,4330,6234,4136,2073,6784,5735,2429,2609,948,8187,3996,7947,7960,6012,9774,2888,179], function() { return __webpack_exec__(73297); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);